import { CookieStorage, CookieOptions } from '../interfaces';

export class NullCookieStorageAdapter implements CookieStorage {
  has(key: string): boolean {
    return false;
  }

  get(key: string): string | undefined {
    return undefined;
  }

  set(key: string, value: string, options?: CookieOptions): void {}
  remove(key: string, options?: CookieOptions): void {}
}
